import React from 'react';

import { Language } from '../../entities/language';
import { strings } from '../../localization/strings';

interface CategoryType {
  id: number;
  label: string;
}

interface ComponentProps {
  languages: Language[];
  selectedLanguage: number;
  selectedType: number;
  types: CategoryType[];
  onLanguageChange: (languageId: number) => void;
  onTypeChange: (type: number) => void;
}

const pillClassName = (isSelected: boolean) =>
  `rounded-full px-3 py-1.5 text-sm font-medium ${
    isSelected ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
  }`;

export default function CategoriesFiltersComponent({
  languages,
  selectedLanguage,
  selectedType,
  types,
  onLanguageChange,
  onTypeChange,
}: ComponentProps) {
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3 border-b border-gray-200 bg-white p-4">
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-sm font-medium text-gray-700">{strings.categories.filters.language}</div>
        {languages.map((language) => (
          <button
            key={language.id}
            type="button"
            className={pillClassName(selectedLanguage === language.id)}
            onClick={() => onLanguageChange(language.id)}
          >
            {language.name}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-sm font-medium text-gray-700">{strings.categories.filters.type}</div>
        {types.map((type) => (
          <button
            key={type.id}
            type="button"
            className={pillClassName(selectedType === type.id)}
            onClick={() => onTypeChange(type.id)}
          >
            {type.label}
          </button>
        ))}
      </div>
    </div>
  );
}
